import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GooglePlacesService } from '../../services/google-places/google-places.service';

@Component({
  selector: 'app-locations-autocomplete',
  templateUrl: './locations-autocomplete.component.html',
  styleUrls: ['./locations-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationsAutocompleteComponent),
      multi: true,
    },
  ],
})
export class LocationsAutocompleteComponent implements OnInit, ControlValueAccessor {

  @Input() placeHolder: string = "Enter location";
  @Output() predictionSelected: EventEmitter<any> = new EventEmitter();
  disabled:boolean = false;

  destination: string = "";
  predictions: google.maps.places.AutocompletePrediction[] = [];
  @Input() placesType: string[] = [];

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private _googlePlacesService: GooglePlacesService,
    private _elementRef: ElementRef
  ) {}

  ngOnInit(): void {}

  onInput(event: any) {
    const input = event;

    if (input && input.length > 2) {
      this._googlePlacesService.getPlacePredictions(input, this.placesType, null)
        .then(predictions => this.predictions = predictions)
        .catch(error => {
          this.predictions = []
        });
    } else {
      this.predictions = [];
    }

    this.onChange(this.destination);
    this.onTouched();
  }

  selectPrediction(prediction: google.maps.places.AutocompletePrediction) {
    this.destination = prediction.description;
    this.predictions = [];
    this.predictionSelected.emit(this.destination);
    this.onChange(this.destination);
    this.onTouched();
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (!this._elementRef.nativeElement.contains(targetElement)) {
      // this.dropdownVisible = false;
      this.predictions = [];
    }
  }

  // ControlValueAccessor interface methods
  writeValue(value: string): void {
    this.destination = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
